import { resolveWoltPhase, type WoltOrderPhase, type WoltStatusAction } from 'shared-models/browser';

const PHASE_LABEL: Record<Exclude<WoltOrderPhase, 'unknown'>, string> = {
  new: 'התקבלה',
  accepted: 'אושרה',
  ready: 'מוכנה',
  delivered: 'נמסרה',
  rejected: 'נדחתה',
  canceled: 'בוטלה',
};

export function woltStatusLabel(status: string | null | undefined): string {
  const phase = resolveWoltPhase(status);
  return phase === 'unknown' ? (status ?? '—') : PHASE_LABEL[phase];
}

// Buttons per phase; reject is the only manager-gated action (voids the order).
export function visibleWoltActions(status: string | null | undefined, isManager: boolean): WoltStatusAction[] {
  switch (resolveWoltPhase(status)) {
    case 'new':
      return isManager ? ['accept', 'reject'] : ['accept'];
    case 'accepted':
      return ['ready'];
    case 'ready':
      return ['delivered'];
    // Closed on Wolt but still open here (void failed): the manager can finish the local void.
    case 'rejected':
    case 'canceled':
      return isManager ? ['reject'] : [];
    default:
      return [];
  }
}
